import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeReportAdminZones, cleanListReportsZones, getListReportsZones } from '../../../admin/actions/reportActions';
import AdminReportsZoneView from '../../../containers/Zones/Admin/AdminReportsZone';

const AdminReportsZone = ({match}) => {
    const dispatch = useDispatch()
    const {isLoadingListReports,listOfReports} = useSelector(state=>state.postAdmin)
    const [tab, setTab] = useState("zonepost")
    const [subTab, setSubTab] = useState("zonepost")
    useEffect(() => {
        
        dispatch(getListReportsZones({
            communityID: match.params.zoneId,
            reportedType:tab=="zonemember" ? tab : subTab ,
         
        }))

        return () => {
            dispatch(cleanListReportsZones())
        };
    }, [match.params.zoneId,tab,subTab]);
    const changeReportAdmin = (values) =>{
        dispatch(changeReportAdminZones(values))
    }
  return <AdminReportsZoneView isLoadingListReports={isLoadingListReports} 
  tab={tab}
  setTab ={setTab}
  subTab={subTab}
  setSubTab ={setSubTab}
  reports={listOfReports}
  reportsMembers={listOfReports.filter(report=>report.reportedType=="zonemember") } reportsPost={listOfReports.filter(report=>report.reportedType=="zonepost") } />
};

export default AdminReportsZone;
